import { Link } from "react-router-dom"
import styled from "styled-components"
import { productlist } from "./Product"
import Info from "./Info"
import { Typography,Drawer,Carousel } from 'antd';
import { useState } from "react";
import { auth } from "../Config";
import Slider from "./Slider";
const { Title } = Typography;
const HomeContainer = styled.div`
        width:88%;
        min-height:220vh;
        padding:16vh 3vw 3vh 22vw;
        display:flex;
        justify-content:space-evenly;
        flex-wrap:wrap;
        @media (max-width:1023px) and (min-width:768px){
            width:97%;
        }
        @media (max-width:767px){
            width:95%;
            padding:16vh 0vw 3vh 5vw;
        }
    `
    const ProductItem = styled.div`
        width:18vw;
        height:45vh;
        background-color:white;
        border-radius:20px;
        box-shadow: 0 0 16px rgb(0 0 0 / 10%);
        display:flex;
        flex-direction:column;
        align-items:center;
        justify-content:space-evenly;
        font-family: Arial, Helvetica, sans-serif;
        transition:0.25s all ease;
        :hover{
            transform: translateY(-3%);
        }
        
        @media (max-width:1023px) and (min-width:768px){
            width:22vw;
        }
        @media (max-width:767px){
            width:40vw;
            margin-bottom:3vh
        }
        .product-name{
            margin:0;
            text-align:center;
            font-size:1.1vmax;
            @media (max-width:1023px) and (min-width:768px){
                font-size:1.5vmin;
            }
            @media (max-width:767px){
                font-size:2.5vmin;
                padding:0 1vw;
            }
        }
        .product-cost{
            color:#f8c052;
            margin:0;
            text-align:center;
            @media (max-width:1023px) and (min-width:768px){
                font-size:1.5vmin;
                
            }
            @media (max-width:767px){
                font-size:2.5vmin;
            }
        }

    `
    const ImgField = styled.div`
        width:80%;
        height:55%;
        overflow:hidden;
        .home-img{
            width:100%;
            height:100%;
            object-fit:cover;
        }
    `
export default function Home(){
    const contentStyle = {
        height: '160px',
        color: '#fff',
        lineHeight: '160px',
        textAlign: 'center',
        background: '#364d79',
      };
    return(
        <div style={{display:'flex',flexDirection:'column'}}>
        <Slider/>
        <HomeContainer>
            {productlist.map((productItem,index) =>(
                <Link to={{pathname:`/home/info${index}?id=${index}`}} key={index}>
                    <ProductItem>
                        <ImgField>
                            <img src={productItem.img}className="home-img"></img>
                        </ImgField>
                        <Title level={5} className='product-name'>{productItem.name}</Title>
                        <Title level={5} className='product-cost'>{productItem.cost}</Title>
                    </ProductItem>
                </Link>
            ))}
        </HomeContainer>
        </div>
    )
}